export type ProductCategoryCard = {
  label: string;
  url: string;
  image: string;
  globalOrder?: number;
};

type ProductItem = {
  label: string;
  path: string;
  image: string;
  globalOrder: number;
};

type ProductCollection = {
  basePath: string;
  items: ProductItem[];
};

type ProductCategories = {
  [key: string]: ProductCollection;
};

export const PRODUCT_CATEGORIES_BY_COLLECTION: ProductCategories = {
  sunCare: {
    basePath: '/collections/sun-care',
    items: [
      {
        label: 'Sun Screen',
        path: 'sun-screen',
        image:
          'https://skin-seoul.com/wp-content/uploads/2025/02/round-lab-birch-juice-moisturizing-sun-cream-50ml_1024x1024.webp',
        globalOrder: 1,
      },
    ],
  },
  moisturizer: {
    basePath: '/collections/moisturizer',
    items: [
      {
        label: 'Essence & Serum',
        path: 'essence-serum-ampoule',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004755_1-1.webp',
        globalOrder: 2,
      },
      {
        label: 'Lotion',
        path: 'lotion',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/05/Lotion-1024x1024.png',
        globalOrder: 3,
      },
      {
        label: 'Facial Cream',
        path: 'facial-cream',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004668_1-1.webp',
        globalOrder: 4,
      },
      {
        label: 'Multi-Balm & Stick',
        path: 'multi-balm-stick',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100005074_1-1.webp',
        globalOrder: 5,
      },
      {
        label: 'Toner',
        path: 'toner',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/05/Dokdo-Toner-Product-Image-768x768.webp',
        globalOrder: 6,
      },
      {
        label: 'Eye & Neck Cream',
        path: 'eye-neck-cream',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/05/Retino-Collagen-Gua-Sha-Cream-1024x1024.png',
        globalOrder: 9,
      },
    ],
  },
  cleanser: {
    basePath: '/collections/cleanser',
    items: [
      {
        label: 'Cleansing Foam',
        path: 'cleansing-foam',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004626_1-1.webp',
        globalOrder: 7,
      },
      {
        label: 'Cleansing Oil',
        path: 'cleansing-oil',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/XXL_p0211190448.webp',
        globalOrder: 10,
      },
    ],
  },
  mask: {
    basePath: '/collections/mask-pack',
    items: [
      {
        label: 'Sheet Mask',
        path: 'sheet-mask',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100002356_1-1.webp',
        globalOrder: 8,
      },
      {
        label: 'Toner Pads',
        path: 'toner-pads',
        image: 'https://skin-seoul.com/wp-content/uploads/2025/02/thu_100004983_1-1.webp',
        globalOrder: 11,
      },
      {
        label: 'Wash-Off Mask',
        path: 'wash-off-mask',
        image: 'https://skin-seoul.com/wp-content/uploads/2024/05/thu_100002163_1-1.webp',
        globalOrder: 12,
      },
    ],
  },
};

const createProductCategoryCards = (categories: ProductCategories): ProductCategoryCard[] => {
  const cards = Object.entries(categories).flatMap(([, { basePath, items }]) =>
    items.map(({ label, path, image, globalOrder }) => ({
      label,
      url: `${basePath}/${path}/`,
      image,
      globalOrder,
    })),
  );

  return [...cards].sort((a, b) => (a.globalOrder || 0) - (b.globalOrder || 0));
};

export const PRODUCT_CATEGORY_CARDS: ProductCategoryCard[] = createProductCategoryCards(
  PRODUCT_CATEGORIES_BY_COLLECTION,
);
